import { render, staticRenderFns } from "./product-simple.vue?vue&type=template&id=071a5831"
import script from "./product-simple.vue?vue&type=script&lang=js"
export * from "./product-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071a5831')) {
      api.createRecord('071a5831', component.options)
    } else {
      api.reload('071a5831', component.options)
    }
    module.hot.accept("./product-simple.vue?vue&type=template&id=071a5831", function () {
      api.rerender('071a5831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/product-simple.vue"
export default component.exports